import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useJourneyStepStats } from '../../../../../api/Journeys/journey_queries';
import { LocalAtmTwoTone, GroupTwoTone, BackspaceTwoTone } from '@mui/icons-material';
import StatsWait from '../../Stats/StatsWait';



const EnterReport = ({ stepId }) => {
    const { id: journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);
    const { status, data, error, isFetching } = useJourneyStepStats(journeyId, stepId);

    return (
        <Box className='flow-sidebar__body' p={0}>
            <Box className='flow-sidebar__body-content'>
                {status === 'loading' ? (
                    'Loading...'
                ) : status === 'error' ? (
                    <span>Error: {error && typeof error === 'object' && 'message' in error ? error.message : 'Unknown error'}</span>
                ) : (
                    <>{isFetching ? 'Background Updating...' : <StatsWait stats={data} flowId={journeyId} stepId={stepId} />}</>
                )}
            </Box>
        </Box>
    );
};

export default EnterReport;
